export default __webpack_public_path__ + "static/media/ic-attempted.34f2db8a.svg";